var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3984 11.9833C11.7791 11.9833 12.8984 10.9143 12.8984 9.59565C12.8984 8.27699 11.7791 7.20801 10.3984 7.20801C9.01773 7.20801 7.89844 8.27699 7.89844 9.59565C7.89844 10.9143 9.01773 11.9833 10.3984 11.9833Z",
    stroke: "#30B3D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.748 6.23229L17.123 5.19844C16.778 4.6272 16.0136 4.43201 15.4155 4.7615L15.0867 4.94296C13.8367 5.6318 12.2742 4.77046 12.2742 3.39219V3.02927C12.2742 2.36968 11.7149 1.83545 11.0242 1.83545H9.77423C9.0836 1.83545 8.52423 2.36968 8.52423 3.02927V3.39219C8.52423 4.77046 6.96172 5.63239 5.71172 4.94296L5.38297 4.7615C4.78485 4.43201 4.02047 4.6272 3.67548 5.19844L3.05048 6.23229C2.70548 6.80353 2.90985 7.53355 3.50797 7.86305L3.83672 8.04451C5.08672 8.73394 5.08672 10.4566 3.83672 11.1461L3.50797 11.3275C2.90985 11.657 2.70548 12.387 3.05048 12.9583L3.67548 13.9921C4.02047 14.5634 4.78485 14.7586 5.38297 14.4291L5.71172 14.2476C6.96172 13.5582 8.52423 14.4201 8.52423 15.7984V16.1613C8.52423 16.8209 9.0836 17.3551 9.77423 17.3551H11.0242C11.7149 17.3551 12.2742 16.8209 12.2742 16.1613V15.7984C12.2742 14.4201 13.8367 13.5582 15.0867 14.2476L15.4155 14.4291C16.0136 14.7586 16.778 14.5634 17.123 13.9921L17.748 12.9583C18.093 12.387 17.8886 11.657 17.2905 11.3275L16.9617 11.1461C15.7117 10.4566 15.7117 8.73394 16.9617 8.04451L17.2905 7.86305C17.8886 7.53355 18.0936 6.80353 17.748 6.23229Z",
    stroke: "#30B3D5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.5e2641b01fc7a1b11aedd7561cbd5955.svg";
export { ForwardRef as ReactComponent };